import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import DataHelper from "@Scripts/Common/DataHelper";
import MeasureUnitHelper from "@Scripts/Infrastructure/MeasureUnitHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "CatalogueProductList" })
export default class CatalogueProductList extends Vue {
    public localizer: any = Localizer;
    public measureUnitHelper: any = MeasureUnitHelper;
    public listIndex: number = 7;
    public isLoading: boolean = true;

    public pageIndex: number = 0;
    public pageCount: number = 0;
    public footerPages: any[] = [];
    public paginatorCount: number = 0;
    public paginatorIndex: number = 0;

    public productItems: any[] = [];
    public topProductFields: string[] = [];
    public familyProductCount: number = null;

    get routes() {
        return (<any>window).App.routes;
    }

    get encodedFilters(): any {
        return this.$store.getters["catalogueStore/encodedFilters"];
    }

    get measureUnits() {
        return this.$store.getters["measureUnitStore/measureUnits"];
    }

    @Watch("encodedFilters") onEncodedFiltersChanged(value: string, oldValue: string) {
        this.getData(value);
    }

    @Prop() readonly familyCode: string;
    @Prop() readonly iscct: boolean;
    @Prop() readonly isAuthenticated: boolean;

    public async created() {
        const urlParams = new URLSearchParams(window.location.search);
        let encodedfilters = urlParams.get("filters");

        await this.getData(encodedfilters);
    }

    public async getData(encodedFilters: string) {
        this.isLoading = true;
        const vm = this;

        let response = (await Axios.post(this.routes.Catalogue_GetProductListData, { familyCode: this.familyCode, filter: encodedFilters, page: this.pageIndex })).data;

        this.productItems = response.products;
        this.topProductFields = response.topProductFields;
        this.familyProductCount = response.familyProductCount;

        this.pageIndex = response.pageIndex;
        this.pageCount = response.pageCount;
        this.paginatorCount = Math.ceil(this.pageCount / 4);
        this.paginatorIndex = Math.trunc((this.pageIndex - 1) / 4);
        this.footerPages = [...Array(this.pageCount).keys()].slice(this.paginatorIndex * 4, (this.paginatorIndex + 1) * 4);

        if (this.topProductFields.length !== 0) {
            this.productItems.sort(function (a, b) {
                let firstComparer = a.product[vm.setCamelCase(vm.topProductFields[0])];
                if (firstComparer instanceof Array) {
                    firstComparer = firstComparer[0];
                }
                let secondComparer = b.product[vm.setCamelCase(vm.topProductFields[0])];
                if (secondComparer instanceof Array) {
                    secondComparer = secondComparer[0];
                }

                if (firstComparer && secondComparer) {
                    if (DataHelper.isNumeric(firstComparer)) {
                        return firstComparer < secondComparer || a.product.orderCode - b.product.orderCode;
                    } else {
                        return firstComparer.localeCompare(secondComparer) || a.product.orderCode - b.product.orderCode;
                    }
                }
            });
        }

        for (const productItem of this.productItems) {
            Vue.set(productItem, "isDetail", false);
        }

        this.isLoading = false;
    }

    public async setProductDetail(productItem: any) {
        if (this.topProductFields.length > 5) {
            productItem.isDetail = !productItem.isDetail;
        } else {
            productItem.isDetail = false;
        }
    }

    public removeFilters() {
        window.location.href = window.location.href.split('?')[0];
    }

    public setCamelCase(value: string) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    }

    public async goToPage(index: number) {
        this.pageIndex = index;

        const urlParams = new URLSearchParams(window.location.search);
        let encodedfilters = urlParams.get("filters");

        await this.getData(encodedfilters);

        this.scrollToProductList();
    }

    public async goToPrevPage() {
        if (this.pageIndex < 2) {
            return;
        }

        this.pageIndex = this.pageIndex - 1;

        const urlParams = new URLSearchParams(window.location.search);
        let encodedfilters = urlParams.get("filters");

        await this.getData(encodedfilters);

        this.scrollToProductList();
    }

    public async goToNextPage() {
        if (this.pageIndex >= this.pageCount) {
            return;
        }

        this.pageIndex = this.pageIndex + 1;

        const urlParams = new URLSearchParams(window.location.search);
        let encodedfilters = urlParams.get("filters");

        await this.getData(encodedfilters);

        this.scrollToProductList();
    }

    public goToPageSelector(type: string) {
        if (type === "plus") {
            this.goToPage(this.footerPages.slice(-1)[0] + 2);
            this.scrollToProductList();
        }

        if (type === "less") {
            this.goToPage(this.footerPages.slice(0)[0]);
            this.scrollToProductList();
        }
    }

    public scrollToProductList() {
        const productList = document.getElementById("ProductList");
        if (productList) {
            productList.scrollIntoView({ behavior: "smooth" });
        }
    }
};